<span data-inner>
  <ng-content select="[data-leading]" />
  <span data-item-label>
    <span data-text [innerHtml]="label()"></span>
    @if (subText()) {
      <span data-sub-text>{{ subText() }}</span>
    }
  </span>
  <ng-content select="[data-trailing]" />
</span>
